<template>
  <div class="text-n-gray-dark">
    <RegisterPageHeader />
    <main id="main" class="max-w-2xl m-auto py-4 md:py-16 px-5">
      <div class="flex flex-col md:flex-row">
        <div class="md:mx-5 flex-no-shrink block w-full md:w-215px">
          <RegisterPageSteps />
          <div class="hidden md:block" v-if="!isLoggedIn">
            <hr class="w-px bg-n-gray border border-n-gray w-full my-10" />
            <p>
              Already have an account? <router-link :to="{ name: 'user-login' }">Log In.</router-link>
            </p>
          </div>
        </div>
        <div class="flex-shrink md:mx-20">
          <slot />

          <div class="text-center text-lg font-sans-book">
            Questions or feedback? We'd love to hear from you.
          </div>
          <div class="text-center text-lg font-sans-book">
            Email us at <a href="mailto:hello@letsreimagine.org">hello@letsreimagine.org</a>.
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import RegisterPageHeader from "./RegisterPageHeader.vue";
import RegisterPageSteps from "./RegisterPageSteps.vue";
import {mapGetters} from "vuex";

export default {
  name: "RegisterPageLayout",
  components: { RegisterPageSteps, RegisterPageHeader },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn'
    })
  },
}
</script>

<style>
  .spacer {
    min-height: 3rem;
  }
</style>